import { ImproveTemplateDto } from "../../../Types/Improve/ImproveTemplateDto";
import {
  ImprovementDetail,
  ImproveTaskDetail,
} from "../../../Types/Improve/ImprovementPlanDetail";

/** Plan-level columns. */
export const IMPROVE_PLAN_COLS = [
  "Plan title",
  "Due date",
  "Owner",
  "Plan status",
] as const;

/** Improvement (objective) level columns. */
export const IMPROVE_IMPROVEMENT_COLS = [
  "Objective",
  "Improvement status",
  "Assigned to",
  "Target date",
  "Completion date",
  "Expected impact",
  "Actual impact",
  "Tags",
  "Custom tags",
  "Custom date",
  "Column A",
  "Column B",
  "Column C",
  "URL 1",
  "URL 2",
  "URL 3",
] as const;

/** Task-level columns. */
export const IMPROVE_TASK_COLS = [
  "Task heading",
  "Task status",
  "Task target date",
  "Task completion date",
  "Task assigned to",
  "Column D",
  "Column E",
  "Column F",
  "Task custom tags",
] as const;

export const IMPROVE_EXPORT_COLS = [
  ...IMPROVE_PLAN_COLS,
  ...IMPROVE_IMPROVEMENT_COLS,
  ...IMPROVE_TASK_COLS,
] as const;

export type ImproveExportColumnKey = (typeof IMPROVE_EXPORT_COLS)[number];

export type ImproveExportFieldVisibility = Record<
  ImproveExportColumnKey,
  boolean
>;

export const DEFAULT_IMPROVE_EXPORT_FIELD_VISIBILITY: ImproveExportFieldVisibility =
  IMPROVE_EXPORT_COLS.reduce(
    (acc, k) => ({ ...acc, [k]: true }),
    {} as ImproveExportFieldVisibility
  );

export function fullImproveExportFieldVisibility(
  partial?: Partial<ImproveExportFieldVisibility>
): ImproveExportFieldVisibility {
  return { ...DEFAULT_IMPROVE_EXPORT_FIELD_VISIBILITY, ...partial };
}

export type ImproveExportOptions = {
  fieldVisibility?: Partial<ImproveExportFieldVisibility>;
};

/** Mirrors backend ImproveAreaExportDto. */
export type ImproveAreaExportData = {
  areaId: string;
  title: string;
  endDate?: string | Date | null;
  ownerName: string;
  status: string;
  improvements: ImprovementDetail[];
  template: ImproveTemplateDto;
};

export type ImproveExporterMeta = {
  label: string;
  extension: string;
  mime: string;
};

export type IImproveAreaExporter = (
  areas: ImproveAreaExportData[],
  baseFilename: string,
  options?: ImproveExportOptions
) => Promise<Blob>;

export type RegisteredImproveExporter = {
  exporter: IImproveAreaExporter;
  meta: ImproveExporterMeta;
};

/** Re-export detail types for helpers. */
export type { ImprovementDetail, ImproveTaskDetail };
